var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1246 -411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(1246 411)",
    fill: "#4fbf26"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1260.342 373.057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.692,58.83,9.447,70.074a2.134,2.134,0,0,1-3.017,0L.624,64.269a2.133,2.133,0,0,1,3.017-3.017l4.3,4.3,9.736-9.736a2.133,2.133,0,0,1,3.017,3.017Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green_check.ad8e46b235e00d3bcdd2078855ae4ec5.svg";
export { ForwardRef as ReactComponent };